import { render, staticRenderFns } from "./expanded-phq9.vue?vue&type=template&id=2e328d9f&scoped=true&lang=pug&"
import script from "./expanded-phq9.vue?vue&type=script&lang=ts&"
export * from "./expanded-phq9.vue?vue&type=script&lang=ts&"
import style0 from "./expanded-phq9.vue?vue&type=style&index=0&id=2e328d9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e328d9f",
  null
  
)

export default component.exports